import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_auth/_side-layout/settings_/organization/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/settings/organization/details' });
  },
});
